import { StoreNavigationHeader } from '../../Types/StoreTypes';

export const SET_NAVIGATION_TITLE = 'SET_NAVIGATION_TITLE';
export const SET_NAVIGATION_SUBTITLE = 'SET_NAVIGATION_SUBTITLE';
export const SET_MOBILE_MENU_OPEN = 'SET_MOBILE_MENU_OPEN';
export const SET_NAVIGATION_IMAGE = 'SET_NAVIGATION_IMAGE';

export function setNavigationTitle(navigationTitle: StoreNavigationHeader['navigationTitle']) {
    return { type: SET_NAVIGATION_TITLE, payload: navigationTitle };
}

export function setNavigationSubTitle(navigationSubTitle: StoreNavigationHeader['navigationSubTitle']) {
    return { type: SET_NAVIGATION_SUBTITLE, payload: navigationSubTitle };
}

export function setNavigationImage(navigationImage: StoreNavigationHeader['navigationImage']) {
    return { type: SET_NAVIGATION_IMAGE, payload: navigationImage };
}

export function setMobileMenuOpen(isMobileMenuOpen: StoreNavigationHeader['isMobileMenuOpen']) {
    return { type: SET_MOBILE_MENU_OPEN, payload: isMobileMenuOpen };
}
